import React, { useState } from "react";
import { ReactComponent as Sort } from "assets/img/icons/sort.svg";
import { ReactComponent as Arrowup } from "assets/img/icons/arrowup.svg";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";
import classNames from "classnames";

function TeamSort({ filterTeam }) {
  const [displaySort, setDisplaySort] = useState(false);
  const [selectedSort, setSelectedSort] = useState(1);
  const [allSortingOptions] = useState([
    {
      id: 1,
      value: "joined_at",
      name: "Newest Team",
      order: "desc",
    },
    {
      id: 2,
      value: "joined_at",
      name: "Oldest Team",
      order: "asc",
    },
    {
      id: 3,
      value: "name",
      name: "Z to A",
      order: "desc",
    },
    {
      id: 4,
      value: "name",
      name: "A to Z",
      order: "asc",
    },
    {
      id: 5,
      value: "activity",
      name: "Recent Activity",
      order: "desc",
    },
  ]);

  const handleSorting = async ({ id, orderBy, order = "desc", orderName }) => {
    try {
      setSelectedSort(id);
      await filterTeam({ sort: { orderBy, order, orderName } });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <div className="sortRoot" onClick={() => setDisplaySort(!displaySort)}>
        <div
          className={classNames({
            sortSvg: !displaySort ? true : false,
            sortsvgActive: displaySort ? true : false,
          })}
        >
          <Sort className="svg" />
        </div>
        <CSSTransition
          in={displaySort}
          timeout={300}
          unmountOnExit
          classNames="dropdown-element"
        >
          <ClickAwayListener onClickAway={() => setDisplaySort(false)}>
            <div
              className="sortContent"
              style={{
                boxShadow:
                  "rgb(204 204 204) 0px 2px 1px -1px, rgb(204 204 204) 0px 1px 1px 0px, rgb(204 204 204) 0px 1px 3px 0px",
              }}
            >
              <Arrowup className="arrowUp" />
              {allSortingOptions.map((option, index) => (
                <span
                  className={classNames({
                    active: option.id === selectedSort ? true : false,
                  })}
                  key={index}
                  onClick={() =>
                    handleSorting({
                      id: option.id,
                      orderBy: option.value,
                      orderName: option.name,
                      order: option.order,
                    })
                  }
                >
                  {option.name}
                </span>
              ))}
            </div>
          </ClickAwayListener>
        </CSSTransition>
      </div>
    </div>
  );
}

export default TeamSort;
